import { Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "../components/ui/command"
import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { cn } from "../lib/utils"

export function CommandRenderer({ element }: RendererProps) {
  const { resolveSymbol, dispatchEvent } = useRenderContext()

  const children = element.children ?? []
  const searchInput = children.find((c) => c.type === "input")
  const groups = children.filter((c) => c.type !== "input")

  const placeholder = searchInput?.placeholder
    ? String(resolveSymbol(searchInput.placeholder) ?? "")
    : "Type a command or search..."

  return (
    <Command
      className={cn(element.className)}
      data-testid={`command-${element.id}`}
      aria-label={element.ariaLabel ?? "Command palette"}
    >
      <CommandInput
        placeholder={placeholder}
        aria-label={searchInput?.ariaLabel ?? "Search commands"}
        onValueChange={(value) => {
          if (searchInput) {
            dispatchEvent(searchInput.id, "change", { value })
          }
        }}
      />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        {groups.map((group) => {
          const groupItems = group.children ?? []
          const items = groupItems.filter((i) => i.type !== "text")
          const label = groupItems.find((i) => i.type === "text")
          const heading = label
            ? String(resolveSymbol(label.text ?? "") ?? "")
            : undefined

          return (
            <CommandGroup key={group.id} heading={heading}>
              {items.map((item) => {
                const itemLabel = item.text
                  ? String(resolveSymbol(item.text) ?? "")
                  : item.id
                return (
                  <CommandItem
                    key={item.id}
                    onSelect={() =>
                      dispatchEvent(item.id, "tap", { value: itemLabel })
                    }
                    aria-label={item.ariaLabel ?? itemLabel}
                  >
                    {itemLabel}
                  </CommandItem>
                )
              })}
            </CommandGroup>
          )
        })}
      </CommandList>
    </Command>
  )
}
